/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const chatShowDataSchema = z.object({
	id: z.string(),
	campaignId: z.string().nullable(),
	extraData: z.record(z.string(), z.unknown()).nullable(),
	messages: z.array(
		z.object({
			id: z.string(),
			role: z.string(),
			parts: z.array(z.record(z.string(), z.unknown())),
			metadata: z.object({ status: z.string() }),
		}),
	),
})

export type ChatShowDataSchema = z.infer<typeof chatShowDataSchema>
